module.exports = __webpack_public_path__ + "static/media/cancel.4ace9687.png";